import { AfterViewInit, Component, HostListener, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { AppConfig } from "../../../../../config/app.config";
import { UserInfo, UserService } from "../../../../shared";
import { MenuService } from "../../../master/services";
import { ForgotUsernameComponent } from "../../forgot-username/forgot-username.component";
import { PasswordResetByAdminComponent } from "../../password-reset-by-admin/password-reset-by-admin.component";
import { LoginService } from "../../services/login.service";
import { LoginStep1Request, LoginStep2Request, LoginStep3Request, RegisterMFARequest } from "../../services/LoginStepInfo";
import { Top5DialogComponent } from "../../top5-dialog/top5-dialog.component";
import { Title } from "@angular/platform-browser";
import { SetEmailDialogComponent } from "../../set-email-dialog/set-email-dialog.component";
import { StringRequest } from "../../services/StringRequest";
import { MissingEmailWarningDialogComponent } from "../../missing-email-warning-dialog/missing-email-warning-dialog.component";
import * as moment from "moment";
import * as shajs from "sha.js";

@Component({
	selector: "caass-normal-login",
	templateUrl: "./normal-login.component.html",
	styleUrls: ["./normal-login.component.css"],
})
export class NormalLoginComponent implements OnInit {
	constructor(
		private loginService: LoginService,
		private userService: UserService,
		private router: Router,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService,
		private title: Title
	) {}

	ngOnInit(): void {
		//
		//	Did SSO Login Fail and redirect back to normal login?
		//
		if (this.ErrorB64 != undefined && this.ErrorB64 != "") {
			var FormattedB64 = this.TranslateToB64(this.ErrorB64);
			this.errorMessage = atob(FormattedB64);
		}

		this.LoginInit = true;

		this.LoginStep = 1;
		this.Username = "";
		this.Password = "";
		this.MFACode = "";
		this.userService.setCurrentUser(null);

		this.loadLoginPageInfo();
		this.loadSSOIdentityProviders();
	}

	@HostListener("window:keydown", ["$event"])
	LogKeys(e: KeyboardEvent) {
		if (this.IsLoading() == true) {
			return;
		}

		//
		// Pressing Enter tries to go to the next page
		//
		if (e.keyCode === 13) {
			try {
				if (this.LoginStep == 1) {
					var button = <HTMLButtonElement>document.getElementById("LoginButton");
					button.click();
				} else if (this.LoginStep == 2) {
					var button = <HTMLButtonElement>document.getElementById("FinishRegisterButton");
					button.click();
				} else if (this.LoginStep == 3) {
					var button = <HTMLButtonElement>document.getElementById("LoginMFAButton");
					button.click();
				}
			} catch (e) {
				e.toString();
			}
		}
	}

	//////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////

	LoginInit: boolean = true;

	@Input() ErrorB64: string = "";
	@Input() CAASS_VERSION: string = "";
	VersionMatch: boolean = false;
	VersionChecked: boolean = false;

	//
	// Form
	//

	DistrictInfoLoading: boolean = true;
	ShowDistrictName: boolean = false;
	DistrictDisplayName: string = "";
	DistrictVersionNumber: string = "";
	HideNormalLogin: boolean = false;
	LoginPageAlert: string = "";
	NonSURedirectUrl: string = "";

	Username: string = "";
	Password: string = "";
	MFACode: string = "";

	//
	// General
	//

	MFAEnabled: boolean = false;

	LoginStep: number = 1;
	Processing: boolean = false;
	errorMessage: any = "";

	Registered: any = true;
	QRImage: string = "";
	ManualCode: string = "";

	SUReplace: number = 0;

	// UserData: any;

	NextUserID: any = -1;
	PersonID: any = -1;
	UserLevelID: any = -1;
	TempToken1: any = "";
	TempToken2: any = "";

	ServerName: string = "";

	SSOIDPLoading: boolean = false;
	lstIdentityProvider: any = [];

	//////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////////

	loadLoginPageInfo() {
		this.DistrictInfoLoading = true;

		var result = this.loginService.LoginPageInfoSelect();
		result.subscribe(
			(response: any) => {
				this.ServerName = response.ServerName;
				this.ShowDistrictName = response.ShowDistrictName;
				this.DistrictDisplayName = response.DistrictDisplayName;
				this.DistrictVersionNumber = response.DistrictVersionNumber;
				this.HideNormalLogin = response.HideNormalLogin;
				this.LoginPageAlert = response.LoginPageAlert;

				if (response.NonSURedirectUrl != undefined) {
					this.NonSURedirectUrl = response.NonSURedirectUrl;
				}

				if (this.NonSURedirectUrl != undefined && this.NonSURedirectUrl != "") {
					window.location.href = this.NonSURedirectUrl;
				}

				this.title.setTitle(this.ServerName + "-Login");

				this.CheckVersion();

				this.DistrictInfoLoading = false;
			},
			(error) => {}
		);
	}

	CheckVersion() {
		this.VersionMatch = String(this.CAASS_VERSION) == String(this.DistrictVersionNumber);

		if (this.VersionMatch == false) {
			console.log("Local Version");
			console.log(this.CAASS_VERSION);
			console.log("District Version Number");
			console.log(this.DistrictVersionNumber);
		}

		this.VersionChecked = true;
	}

	loadSSOIdentityProviders() {
		this.SSOIDPLoading = true;

		var result = this.loginService.IdentityProviderSelectList();
		result.subscribe(
			(response: any) => {
				this.lstIdentityProvider = response;

				this.SSOIDPLoading = false;
			},
			(error) => {
				this.SSOIDPLoading = false;
			}
		);
	}

	//////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////

	///////////////////////
	//
	//#region  New Method
	//
	///////////////////////

	//
	//#region Step 1
	//
	onLogin() {
		this.errorMessage = "";
		this.NextUserID = -1;

		//
		// Error handling
		//

		if (this.Username == "") {
			this.errorMessage = "Enter a Username";
			return;
		}
		if (this.Password == "") {
			this.errorMessage = "Enter a Password";
			return;
		}

		this.Processing = true;

		var PasswordHash = String(shajs("sha256").update(this.Password).digest("hex")).toUpperCase();

		var parms: LoginStep1Request = {
			Username: this.Username,
			Password: PasswordHash,
			SuLoginEnabled: false,
			LoginType: 1, // CAASS
		};

		var result = this.loginService.LoginStep1(parms);
		result.subscribe(
			(response: any) => {
				var data: any = response;

				//
				// Is the username and password correct?
				// (Other checks are done on back-end)
				//
				if (data.IsValid == false) {
					this.errorMessage = data.ErrorMessage;
					this.Processing = false;
					return;
				}

				this.NextUserID = data.UserID;
				this.TempToken1 = data.TempToken;
				this.Registered = data.MFARegistered;
				this.SUReplace = data.SUReplace == true ? 1 : 0;

				//
				// Using MFA?
				//
				if (data.MFAEnabled == true) {
					//
					// MFA Already registered, wait for the user to type it in
					//
					if (data.MFARegistered == true) {
						this.onCheckMFA();
					}
					//
					// MFA not registered, get the QR code
					//
					else {
						this.onRegisterMFA();
					}
				}
				//
				// No MFA, skip step
				//
				else {
					this.onLoginStep2();
				}
			},
			(error) => {
				this.Processing = false;
				this.errorMessage = error;
			}
		);
	}

	//#endregion
	//

	//
	//#region Register MFA
	//
	onRegisterMFA() {
		this.Processing = true;

		var parms: RegisterMFARequest = {
			UserID: this.NextUserID,
			TempToken1: this.TempToken1,
		};

		var result = this.loginService.RegisterForMFA(parms);
		result.subscribe(
			(response: any) => {
				var data: any = response;

				if (data.TokenValid == false) {
					this.Processing = false;
					this.errorMessage = data.ErrorMessage;
					return;
				}

				this.QRImage = data.QRCodeBase64;
				this.ManualCode = data.ManualCode;

				this.LoginStep = 2;
				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
				this.errorMessage = error;
			}
		);
	}

	onCancelRegister() {
		this.errorMessage = "";
		this.Processing = false;

		this.Username = "";
		this.Password = "";

		this.TempToken1 = "";
		this.TempToken2 = "";
		this.Registered = false;

		this.NextUserID = -1;
		this.PersonID = -1;
		this.UserLevelID = -1;

		this.ManualCode = "";
		this.QRImage = "";

		this.LoginStep = 1;

		this.userService.setCurrentUser(null);
	}

	onCheckMFA() {
		this.Processing = false;
		this.LoginStep = 3;
	}

	//#endregion
	//

	//
	//#region Enter MFA
	//

	onLoginStep2() {
		this.Processing = true;

		var parms: LoginStep2Request = {
			UserID: this.NextUserID,
			TempToken1: this.TempToken1,
			MFACode: this.MFACode,
			SUReplace: this.SUReplace,
		};

		var result = this.loginService.LoginStep2(parms);
		result.subscribe(
			(response: any) => {
				var data: any = response;

				if (data.MFAValid == false) {
					this.Processing = false;
					this.errorMessage = data.ErrorMessage;
					return;
				}

				this.TempToken2 = data.TempToken;
				this.PersonID = data.PersonID;
				this.UserLevelID = data.UserLevelID;

				if (data.PasswordExpired == true) {
					this.ConfirmPasswordExpired(data);
				} else if (data.SetByAdmin == true) {
					this.ConfirmPasswordResetByAdmin(data);
				} else if (data.MissingEmail == true) {
					this.ConfirmMissingEmail();
				} else {
					this.onLoginStep3();
				}
			},
			(error) => {
				this.Processing = false;
				this.errorMessage = error;
			}
		);
	}

	ConfirmPasswordExpired(LoginStep2Data: any) {
		//
		// Confirm dialog
		//

		this.confirmationService.confirm({
			key: "login1",
			acceptLabel: "Ok",
			rejectVisible: false,
			message: "You password has expired. Please enter a new password",
			header: "Validate Password",
			icon: "fa",
			accept: () => {
				this.ResetPasswordDialog(LoginStep2Data);
			},
			reject: () => {
				this.ResetPasswordDialog(LoginStep2Data);
			},
		});
	}

	ConfirmPasswordResetByAdmin(LoginStep2Data: any) {
		//
		// Confirm dialog
		//

		this.confirmationService.confirm({
			key: "login2",
			acceptLabel: "Ok",
			rejectVisible: false,
			message: "You password was reset by an administrator. Please enter a new password",
			header: "Validate Password",
			icon: "fa",
			accept: () => {
				this.ResetPasswordDialog(LoginStep2Data);
			},
			reject: () => {
				this.ResetPasswordDialog(LoginStep2Data);
			},
		});
	}

	ResetPasswordDialog(LoginStep2Data: any) {
		//
		// Reset Dialog
		//

		var ref = this.dialogService.open(PasswordResetByAdminComponent, {
			header: "Change Password",
			width: "fit-content",
			data: {
				loginInfo: {
					userName: this.Username,
					userID: this.NextUserID,
				},
				TempToken2: this.TempToken2,
			},
			closable: false,
			closeOnEscape: false,
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				if (LoginStep2Data.MissingEmail == true) {
					this.ConfirmMissingEmail();
				} else {
					this.onLoginStep3();
				}
			} else {
				this.onLoginStep2();
			}
		});
	}

	ConfirmMissingEmail() {
		//
		// Confirm dialog
		//

		this.confirmationService.confirm({
			key: "login4",
			acceptLabel: "Ok",
			rejectVisible: false,
			message:
				"You don't have an email associated with your account. Please enter your email address. This is the email that will be used if you ever reset your password or forget your email.",
			header: "Missing Email",
			icon: "fa",
			accept: () => {
				this.MissingEmailDialog();
			},
			reject: () => {
				this.MissingEmailDialog();
			},
		});
	}

	MissingEmailDialog() {
		//
		// Reset Dialog
		//

		var ref = this.dialogService.open(SetEmailDialogComponent, {
			header: "Set Email",
			width: "fit-content",
			data: {
				loginInfo: {
					userName: this.Username,
					userID: this.NextUserID,
				},
				TempToken2: this.TempToken2,
			},
			closable: false,
			closeOnEscape: false,
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onLoginStep3();
			} else {
				this.onLoginStep2();
			}
		});
	}

	onCancelMFA() {
		this.errorMessage = "";
		this.Processing = false;

		this.MFACode = "";

		if (this.Registered == false) {
			this.LoginStep = 2;
		} else {
			this.onCancelRegister();
		}
	}

	//#endregion
	//

	onLoginStep3() {
		this.Processing = true;

		var parms: LoginStep3Request = {
			UserID: this.NextUserID,
			TempToken2: this.TempToken2,
			SUReplace: this.SUReplace,
		};

		var result = this.loginService.LoginStep3(parms);
		result.subscribe(
			(response: any) => {
				var data: any = response;

				if (data.TokenValid == false) {
					this.Processing = false;
					this.errorMessage = data.ErrorMessage;
					this.onCancelRegister();
					return;
				}

				//
				// Set User/Access Token
				//
				var user = new UserInfo();
				user.c_date = moment(new Date()).format("MM/DD/YYYY");
				user.isLoggedIn = true;
				user.token = data.AccessToken;
				user.refresh_token = data.RefreshToken;
				user.token_expiration = data.Expiration;
				user.userID = this.NextUserID;
				user.personID = this.PersonID;
				user.userName = this.Username;
				user.UserLevelID = this.UserLevelID;
				// user.HasClassRoomAttendanceAccess = data.HasClassRoomAttendanceAccess;
				// user.HasPrintAccess = data.HasPrintAccess;
				// user.HasVisitorAccess = data.HasVisitorAccess;

				this.userService.setCurrentUser(user);

				//
				// Navigate to User's default page
				//
				var DefaultPage = data.DefaultPageRoute;

				DefaultPage = String(DefaultPage).toLowerCase();

				//
				// Homepage automatically opens Top 5 Popup
				// If not homepage/normal dashboard open top 5
				//
				if (DefaultPage != "/") {
					//
					// Open Top 5
					//
					var ref = this.dialogService.open(Top5DialogComponent, {
						header: "Items Needing Administrator's Attention",
						width: "fit-content",
						data: {},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				}

				this.router.navigate([DefaultPage]);
			},
			(error) => {
				this.Processing = false;
				this.errorMessage = error;
			}
		);
	}

	///////////////////////
	//
	//#endregion
	//
	///////////////////////

	onForgotPassword() {
		this.errorMessage = "";

		// return; //Not finished

		//Error handling
		if (this.Username == "" || this.Username == undefined) {
			// this.errorLogin = "Enter a username and press forgot password to reset your password";

			this.confirmationService.confirm({
				key: "login2",
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Enter a username and press forgot password to reset your password",
				header: "ERROR",
				icon: "fa",
				accept: () => {},
			});

			return;
		} else if (String(this.Username).toLowerCase() == "su") {
			// this.errorLogin = "Cannot reset password for SU";

			this.confirmationService.confirm({
				key: "login2",
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Cannot reset password for SU",
				header: "ERROR",
				icon: "fa",
				accept: () => {},
			});

			return;
		}

		//Are you sure? Dialog
		else {
			var ConfirmMSG = "You have clicked forgot password. The password for " + this.Username + " will be reset. Do you want to continue?";

			this.confirmationService.confirm({
				key: "login2",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message: ConfirmMSG,
				header: "Reset Password",
				icon: "fa",
				accept: () => {
					this.ResetPasswordCheckEmail();
				},
			});
		}
	}

	ResetPasswordCheckEmail() {
		var parms: StringRequest = {
			str: this.Username,
		};

		var result = this.loginService.UserHasEmail(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					this.FinishResetPassword();
				} else {
					var ref = this.dialogService.open(MissingEmailWarningDialogComponent, {
						header: "Missing Email",
						width: "fit-content",
						data: {
							Username: this.Username,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				}
			},
			(error) => {
				this.errorMessage = error;
			}
		);
	}

	FinishResetPassword() {
		this.Processing = true;

		var result = this.loginService.UserForgotPassword(this.Username);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					this.confirmationService.confirm({
						key: "login3",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "We've emailed you a Password Reset Link to your email. You should be receiving it shortly.",
						header: "Reset Password",
						icon: "fa",
						accept: () => {
							this.Processing = false;
						},
					});
				} else {
					this.confirmationService.confirm({
						key: "login3",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Error processing reset password request: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {
							this.Processing = false;
						},
					});
				}
			},
			(error) => {
				this.confirmationService.confirm({
					key: "login3",
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "Error processing reset password request",
					header: "ERROR",
					icon: "fa",
					accept: () => {
						this.Processing = false;
					},
				});
			}
		);
	}

	onForgotUserName() {
		var ref = this.dialogService.open(ForgotUsernameComponent, {
			header: "Forgot Username",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
			}
		});
	}

	onForgotMFA() {
		this.errorMessage = "";

		//Error handling
		if (this.Username == "" || this.Username == undefined) {
			this.confirmationService.confirm({
				key: "login2",
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Enter a username and press forgot MFA to reset your MFA Code",
				header: "ERROR",
				icon: "fa",
				accept: () => {},
			});

			return;
		} else if (String(this.Username).toLowerCase() == "su") {
			// this.errorLogin = "Cannot reset password for SU";

			this.confirmationService.confirm({
				key: "login2",
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Cannot reset MFA for SU",
				header: "ERROR",
				icon: "fa",
				accept: () => {},
			});

			return;
		}

		//Are you sure? Dialog
		else {
			var ConfirmMSG =
				"You have clicked forgot MFA. The MFA for " +
				this.Username +
				" will be reset and you will have to delete your existing entry on Authenticator. Do you want to continue?";

			this.confirmationService.confirm({
				key: "login2",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message: ConfirmMSG,
				header: "Reset MFA",
				icon: "fa",
				accept: () => {
					this.ResetMFACheckEmail();
				},
			});
		}
	}

	ResetMFACheckEmail() {
		var parms: StringRequest = {
			str: this.Username,
		};

		var result = this.loginService.UserHasEmail(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					this.FinishResetMFA();
				} else {
					var ref = this.dialogService.open(MissingEmailWarningDialogComponent, {
						header: "Missing Email",
						width: "fit-content",
						data: {
							Username: this.Username,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				}
			},
			(error) => {
				this.errorMessage = error;
			}
		);
	}

	FinishResetMFA() {
		this.Processing = true;

		var result = this.loginService.UserForgotMFA(this.Username);
		result.subscribe(
			(response) => {
				var MSG = response[0];

				if (MSG != undefined) {
					this.confirmationService.confirm({
						key: "login3",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: MSG,
						header: "Reset MFA",
						icon: "fa",
						accept: () => {
							this.Processing = false;
						},
					});
				} else {
					this.confirmationService.confirm({
						key: "login3",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Error processing reset MFA request",
						header: "ERROR",
						icon: "fa",
						accept: () => {
							this.Processing = false;
						},
					});
				}
			},
			(error) => {
				this.confirmationService.confirm({
					key: "login3",
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "Error processing reset MFA request",
					header: "ERROR",
					icon: "fa",
					accept: () => {
						this.Processing = false;
					},
				});
			}
		);
	}

	//
	//	SSO/SAML Login
	//
	onSSOButton(ButtonInfo) {
		var a = document.createElement("a"); //Create <a>
		a.href = ButtonInfo.LoginButtonLink;
		a.click();
	}

	//////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////

	IsLoading() {
		return this.Processing == true;
	}

	ReplaceAllOccur(source: string, searchFor: string, replaceWith: string): string {
		let ans: string = source;

		while (ans.indexOf(searchFor) != -1) {
			ans = ans.replace(searchFor, replaceWith);
		}

		return ans;
	}

	TranslateToB64(input: string): string {
		let ans: string = input;

		ans = this.ReplaceAllOccur(ans, "$", "+");
		ans = this.ReplaceAllOccur(ans, "_", "/");
		ans = this.ReplaceAllOccur(ans, "-", "=");
		ans = this.ReplaceAllOccur(ans, "~", ";");

		return ans;
	}

	//////////////////////////////////////////////////////////////
}
